import { useCallback, useState } from 'react';

import { StoreLocatorViews } from '../types';

export default function useStoreLocatorView() {
  const [currentView, setCurrentView] = useState(StoreLocatorViews.LIST_VIEW);

  const updateCurrentView = useCallback((newView: StoreLocatorViews) => {
    // switch view state
    setCurrentView(newView);
  }, []);

  return {
    currentView,
    currentViewIsList: currentView === StoreLocatorViews.LIST_VIEW,
    currentViewIsMap: currentView === StoreLocatorViews.MAP_VIEW,
    updateStoreLocatorView: updateCurrentView,
  };
}
